// sub-modules
import './single/singleTask';
import './search/taskSearch';
import './groups/taskGroups';
import '../websked-core/services/feature-flag/featureFlag';

// styles & components
import components from './components';

// templates
import overviewTemplate from './overview/tasks.overview.html';
import standaloneForm from './form/tasks.form.html';

// controllers
import overviewController from './overview/TasksOverviewController';
import TasksFeedController from './tasks-feed/TasksFeedController';
import StandaloneTaskFormController from './form/StandaloneTaskFormController';

// services
import taskModalService from './services/taskModalService';
import TaskTemplate from './services/TaskTemplate/TaskTemplate';

const module = angular.module('websked.tasks', [
  'websked.tasks.task',
  'websked.tasks.search',
  'websked.task.groups'
]);

const toLoad = [
  overviewController,
  TasksFeedController,
  StandaloneTaskFormController,
  taskModalService,
  components,
  TaskTemplate
];

function taskRoutes($stateProvider) {
  $stateProvider
    .state('tasks', {
      abstract: true,
      url: '/tasks',
      template: '<div ui-view></div>',
      resolve: {
        loadPlatforms: [
          'platformService',
          (platformService) => {
            platformService.getAll().then((platforms) => platforms);
          }
        ],
        distributors: [
          'distributorService',
          (distributorService) => distributorService.getByType('distributors')
        ]
      }
    })

    .state('tasks.overview', {
      url: '/tasks-overview',
      controller: 'TasksOverviewController',
      template: overviewTemplate,
      data: {
        pageTitle: {
          de: 'Aufgabenübersicht',
          en: 'Tasks Overview',
          es: 'Vista General de Tareas',
          fr: 'Synthèse des Tâches'
        }
      }
    })

    .state('tasks.new', {
      url: '/new?storyID',
      controller: 'StandaloneTaskFormController',
      template: standaloneForm,
      data: {
        pageTitle: {
          de: 'Neue Aufgabe',
          en: 'New Task',
          es: 'Nueva Tarea',
          fr: 'Nouvelle Tâche'
        }
      }
    })

    .state('taskForm', {
      url: '/task-form?storyID',
      controller: 'StandaloneTaskFormController',
      template: '<task-form task="task" external="external"></task-form>',
      data: {
        pageTitle: {
          de: 'Neue Aufgabe',
          en: 'New Task',
          es: 'Nueva Tarea',
          fr: 'Nouvelle Tâche'
        }
      }
    });
}

module.config(['$stateProvider', taskRoutes]);

toLoad.forEach((fn) => fn(module));
